import { CartQuantityActionEnum } from '../enum';

export function getUpdatedCartQuantity(
	currentQuantity: bigint | undefined,
	value: number | string | undefined
): bigint | null {
	if (!value || !currentQuantity) {
		return null;
	}

	return BigInt(value);
}

export function increaseCartQuantity(currentQuantity: bigint | undefined): bigint | null {
	if (!currentQuantity) {
		return null;
	}

	return currentQuantity + 1n;
}

export function decreaseCartQuantity(
	currentQuantity: bigint | undefined
): { action: CartQuantityActionEnum, quantity?: bigint } | null {
	if (!currentQuantity) {
		return null;
	}

	if (currentQuantity > 1n) {
		return { action: CartQuantityActionEnum.Update, quantity: currentQuantity - 1n };
	}

	return { action: CartQuantityActionEnum.Remove };
}
